<template>
  <header class="main-header">
    <!-- Logo -->
    <router-link to="/" class="logo" style="
        background-color: #fff;
        border-bottom: 0.5px solid #d2d6de;"
    >
      <!-- mini logo for sidebar mini 50x50 pixels -->
      <span class="logo-mini"><img src="https://demo.micromuneem.com/hdpi.png" width="40px"/></span>
      <!-- <span class="logo-mini"><img src="https://www.toppersolution.com/images/logo-fav.png" width="40px"/></span> -->
      <!-- logo for regular state and mobile devices -->
      <!-- <span class="logo-lg"><img src="https://www.toppersolution.com/images/logo.png" width="200px"></span> -->
      <span class="logo-lg"><img src="https://demo.micromuneem.com/MicroMuneem-Logo.webp" width="200px"></span>
    </router-link>
    <!-- Header Navbar: style can be found in header.less -->
    <nav class="navbar navbar-static-top">
      <!-- Sidebar toggle button-->
      <a href="#" class="sidebar-toggle" data-toggle="push-menu" role="button">
        <span class="sr-only">Toggle navigation</span>
      </a>
      
      <!-- Navbar Right Menu -->
      
      <div class="navbar-custom-menu">
        <ul class="nav navbar-nav"> 
          <li v-if="currentUser.type == 'admin' || currentUser.role_id == 5"><router-link to="daybook" class="btn btn-flat hidden-xs"><strong>Day Book</strong></router-link></li>         
          <li v-if="currentUser.type == 'admin'"><router-link to="voucher" class="btn btn-flat hidden-xs"><strong>Voucher Entries</strong></router-link></li>         
          <li v-if="currentUser.type == 'admin'"><router-link to="paymentvoucher" class="btn btn-flat hidden-xs"><strong>Payment </strong></router-link></li>         
          <li v-if="currentUser.type == 'admin'"><router-link to="receiptvoucher" class="btn btn-flat hidden-xs"><strong>Receipt </strong></router-link></li>         
          <li v-if="currentUser.type == 'admin'"><router-link to="contravoucher" class="btn btn-flat hidden-xs"><strong>Contra </strong></router-link></li>         
          <li v-if="currentUser.type == 'admin'"><router-link to="journalvoucher" class="btn btn-flat hidden-xs"><strong>Journal </strong></router-link></li>         
          <!-- User Account: style can be found in dropdown.less -->
          <li class="dropdown user user-menu" v-if="this.$store.state.user.name">
            <a href="#" class="dropdown-toggle" data-toggle="dropdown">
              <!-- <img src="~admin-lte/dist/img/user2-160x160.jpg" class="user-image" alt="User Image"> -->
              <span class="hidden-xs">{{ currentUser.name.toUpperCase() }}</span>
              <span class="visible-xs"><i class="fa fa-user"></i></span>
            </a>
            <ul class="dropdown-menu">
              <!-- User image -->
              <li class="user-header">
                <img
                  class="profile-user-img img-circle"
                  :src="photo"
                  alt="User profile picture"
                />
                <!-- <img src="~admin-lte/dist/img/user2-160x160.jpg" class="img-circle" alt="User Image"> -->
                <p>
                  {{ currentUser.name.toUpperCase() }} - {{ currentUser.role.name }}
                  <small>{{ currentUser.createdAt }}</small>
                </p>
              </li>
              <!-- Menu Body -->
              <!-- <li class="user-body"> -->
                <!-- <row>
                  <div class="col-xs-4 text-center">
                    <a href="#">Followers</a>
                  </div>
                  <div class="col-xs-4 text-center">
                    <a href="#">Sales</a>
                  </div>
                  <div class="col-xs-4 text-center">
                    <a href="#">Friends</a>
                  </div>
                </row> -->
                <!-- /.row -->
              <!-- </li> -->
              <!-- Menu Footer-->
              <li class="user-footer">
                <div class="pull-left">
                  <!-- <a href="#" class="btn btn-default btn-flat">Profile</a> -->
                  <router-link to="profile" class="btn btn-default btn-flat">Profile</router-link>
                </div>
                <div class="pull-right">
                  <a @click="logout()" class="btn btn-default btn-flat">Sign out</a>
                </div>
              </li>
            </ul>
          </li>
          <!-- Control Sidebar Toggle Button -->
          <!-- <li>
            <a href="#" data-toggle="control-sidebar"><i class="fa fa-gears"></i></a>
            <router-link to="profile"><i class="fa fa-gears"></i></router-link>
          </li> -->
          <!-- <li>
            <a @click="pageReload()" title="Reload Component"><i class="fa fa-refresh"></i></a>
          </li> -->
          <li>
            <a @click="logout()" title="Logout User" class="btn btn-lg btn-danger" style="color:#fff; background-color: red"><i class="fa fa-power-off"></i></a>
          </li>
        </ul>
        
      </div>
    </nav>
  </header>
</template>

<script>
import { mapGetters, mapState } from 'vuex'

export default {
  name: 'va-navibar',
  data () {
    return {
      photo: 'https://via.placeholder.com/100/ffefda/000000?text=Photo'
    }
  },
  computed: {
    ...mapGetters([
      'unreadMessagesCount',
      'unreadNotificationsCount',
      'remainTasksCount',
      'currentUser'
    ]),
    ...mapState([
      'profile'
    ])
  },
  methods: {
    pageReload () {
      window.location.reload(true)
    },
    logout () {
      let loader = this.$loading.show()
      this.$axios.get('/auth/logout', { headers: {'Authorization': 'Bearer ' + localStorage.token} }).then(response => response.data).then(data => {
        console.log(data)
        this.$store.state.user = {}
        this.$store.state.loggedIn = false
        localStorage.removeItem('token')
        Swal.fire({
          position: 'top-end',
          icon: 'success',
          title: 'Logout successfully.',
          showConfirmButton: false,
          timer: 1500
        })
        loader.hide()
        this.$router.push({'path': '/login'})
      }).catch(function (error) {
        this.error = error.response
        this.$router.push({'path': '/login'})
      }.bind(this))
    },
    getImage () {
      if (this.profile.photo != null) {
        this.photo = this.$store.state.imageBaseUrl + this.profile.user_id + '/photo/' + this.profile.photo
      } else {
        this.photo = 'https://via.placeholder.com/100/ffefda/000000?text=Photo'
      }
    }
  },
  created () {
    // alert('6')
    this.getImage()
  }
}

</script>
<style>
.red {
  color:black
}
.invalid-feedback {
  color: red
}
.table.vgt-table {
    font-size: 13.5px !important;
}
</style>



// WEBPACK FOOTER //
// NaviBar.vue?0aa5038b